module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("defaultplayer", [["div",{"class":"form-container"},[["div",{"id":""},[],[["playerContainerId","id",true]]],["div",{"style":"display: none;text-align: center;"},[["div",{"id":"tipme-form","class":"tipme-container","style":"display:inline-block;"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/templates/defaultPlayer.tpl
// module id = 728
// module chunks = 4